import type { ReferralData } from '../model/interfaces'

import { useToast } from '@shared/lib/toast'
import { useCsRoutes } from '@shared/api'

import { useReferralStore } from '../model/store'

interface ReferralDataApiReturn {
  fetchReferralData: () => Promise<void>
}

export const useReferralDataApi = (): ReferralDataApiReturn => {
  const { $axios } = useNuxtApp()
  const referralStore = useReferralStore()
  const toast = useToast()

  const fetchReferralData = async (): Promise<void> => {
    const url = useCsRoutes('referral')

    if (!url) {
      console.warn('missing url for referral/referral-data.hook.ts')
      return
    }

    try {
      referralStore.setLoading(true)
      const { data } = await $axios.get(url)

      if (data?.success) {
        referralStore.setReferralData(data?.data as ReferralData)
      }
    } catch (err: any) {
      console.error('unable to retrieve referral/referral-data.hook.ts:', err)

      toast.error({
        title: 'Error',
        description: err.message ?? 'Something went wrong',
      })
    } finally {
      referralStore.setLoading(false)
    }
  }

  return { fetchReferralData }
}
